import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_7 = { class: "bg-white text-gray-600 space-y-3 text-xs sm:text-sm lg:text-lg p-3" }
const _hoisted_8 = { class: "rounded-lg flex flex-col items-center text-center p-1" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "w-32 h-32 object-cover rounded-full border-2 border-white shadow-md flex items-center justify-center font-semibold text-3xl text-gray-700 bg-[radial-gradient(circle,_white_0%,_#d1d5db_100%)]"
}
const _hoisted_11 = { class: "leading-none text-gray-500 mb-1 text-xl" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "border border-gray-200 shadow-md rounded-lg p-4 gap-3"
}
const _hoisted_14 = { class: "text-lg text-center uppercase" }
const _hoisted_15 = { class: "flex flex-col lg:flex-row lg:gap-3" }
const _hoisted_16 = {
  key: 0,
  class: "flex text-left flex-col lg:flex-row border border-gray-200 shadow-md rounded-lg p-4 lg:gap-3 lg:w-1/2"
}
const _hoisted_17 = { class: "w-full flex flex-row space-x-3" }
const _hoisted_18 = { class: "w-full flex flex-col" }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "flex text-left flex-col border border-gray-200 shadow-lg rounded-lg p-4 md:pl-6 gap-1 lg:w-1/2" }
const _hoisted_22 = { class: "w-full" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["empresaRedSocial"]
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { href: "{{empresaRedSocial.link}}" }
const _hoisted_27 = {
  key: 1,
  class: "w-full grid grid-cols-1 gap-4"
}
const _hoisted_28 = ["producto"]
const _hoisted_29 = { class: "grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5 border border-gray-200 shadow-lg rounded-lg p-4 gap-3 h-full" }
const _hoisted_30 = { class: "lg:col-span-1 w-full aspect-square overflow-hidden rounded-lg" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "lg:col-span-3 xl:col-span-4 flex flex-col text-justify" }
const _hoisted_33 = { class: "text-2xl" }
const _hoisted_34 = { class: "text-gray-600 mt-1" }
const _hoisted_35 = {
  key: 2,
  class: "flex text-left flex-col border border-gray-200 shadow-lg rounded-lg p-4 gap-1"
}
const _hoisted_36 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_37 = { class: "w-full px-2" }
const _hoisted_38 = { class: "block mb-2 text-xs" }
const _hoisted_39 = { class: "flex flex-wrap gap-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-8/12 lg:w-7/12",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.closeDialog()), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'fa-building'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.empresa.nombreFantasia), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.empresa.previewLogo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.empresa.previewLogo,
                          class: "w-32 h-32 object-cover rounded-full border-2 border-white shadow-md"
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.iniciales(_ctx.empresa.nombreFantasia, '')), 1)
                        ])),
                    _createElementVNode("div", {
                      innerHTML: _ctx.empresa.breveDescripcion,
                      class: "text-justify md:text-center"
                    }, null, 8, _hoisted_12)
                  ]),
                  (_ctx.empresa.stand || _ctx.empresa.pabellon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'store'] }),
                          _createTextVNode(" PABELLÓN " + _toDisplayString(_ctx.empresa.pabellon) + " - STAND " + _toDisplayString(_ctx.empresa.stand), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.empresa.domicilio || _ctx.empresa.localidad || _ctx.empresa.provincia)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'location-dot'] })
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.empresa.domicilio), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.empresa.localidad), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.empresa.provincia), 1),
                              _createElementVNode("span", null, "CP : " + _toDisplayString(_ctx.empresa.codigoPostal), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.empresa.pais.descripcion), 1),
                              _createElementVNode("a", {
                                href: 'tel:// ' + _ctx.empresa.mailComercial
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['fas', 'phone'],
                                  class: "mr-2"
                                }),
                                _createTextVNode(_toDisplayString(_ctx.empresa.telefono), 1)
                              ], 8, _hoisted_19),
                              (_ctx.googleMapsUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _ctx.googleMapsUrl,
                                    target: "_blank",
                                    class: "text-blue-500 underline"
                                  }, " ¿Cómo llegar? ", 8, _hoisted_20))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("a", {
                          href: 'mailto: ' + _ctx.empresa.mailComercial
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['far', 'envelope'],
                            class: "mr-1"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.empresa.mailComercial), 1)
                        ], 8, _hoisted_23)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empresa.empresaRedesSociales?.filter(r => r.link), (empresaRedSocial) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: empresaRedSocial.id,
                          empresaRedSocial: empresaRedSocial
                        }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: empresaRedSocial.redSocial.icono.split(' '),
                              class: "mr-1"
                            }, null, 8, ["icon"]),
                            _createElementVNode("a", _hoisted_26, _toDisplayString(empresaRedSocial.link), 1)
                          ])
                        ], 8, _hoisted_24))
                      }), 128))
                    ])
                  ]),
                  (_ctx.empresa.productos)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empresa.productos, (producto) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: producto.id,
                            producto: producto
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("img", {
                                  src: producto.previewFotoFile,
                                  class: "w-full h-full object-cover object-center"
                                }, null, 8, _hoisted_31)
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(producto.descripcion), 1),
                                _createElementVNode("div", _hoisted_34, _toDisplayString(producto.detalles), 1)
                              ])
                            ])
                          ], 8, _hoisted_28))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.empresa.empresaTags)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, ([tagId, { tag, tagOpciones }]) => {
                          return (_openBlock(), _createElementBlock("div", { key: tagId }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("label", _hoisted_38, _toDisplayString(tag.descripcion), 1),
                                _createElementVNode("div", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagOpciones, (tagOpcion) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: tagOpcion.id,
                                      class: "px-3 py-1 bg-gray-200 rounded-lg"
                                    }, _toDisplayString(tagOpcion.descripcion), 1))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog())),
                    class: "w-full block cursor-pointer text-lg font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-lg transform transition-transform duration-200 hover:hover:scale-[100.5%]"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cerrar')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}